export function init($form) {
    let form = $($form);

    if (!form.length) {
        return;
    }

    form.parsley({
        successClass: 'has-success',
        errorClass: 'has-error',
        errorsWrapper: '<ul class="form__group-errors"></ul>',
        errorTemplate: '<li class="form__group-error"></li>',
        focus: true,
        classHandler(el) {
            return el.$element.parents('.form-input-group');
        },
        errorsContainer(el) {
            return el.$element.parents('.form-input-group');
        }
    });

    window.Parsley.on('form:error', function () {
        const errors = form.find('.has-error');

        if (errors.length) {
            $('html, body').animate({scrollTop: errors.eq(0).offset().top - ($('.js-site-header').height() + $('.js-menu-indicator-secondary').height())}, 600);
        }
    });

    form.submit(function (e) {
        e.preventDefault();
        e.stopPropagation();

        let form = $(this);
        let message = form.find($form + '-message');
        let errorTxt = message.find('span.error-mes').html();
        let successTxt = message.find('span.success-mes').html();
        let button = form.find($form + '-button');

        if (!message.find('.response').length)
            message.append('<div class="response"></div>');

        button.attr('disabled', 'disabled');

        message.slideUp();

        let data = {};

        form.addClass('is-loading');

        form.find('input, textarea, select').each(function () {
            if ($(this).attr('name')) {
                let name = $(this).attr('name');

                if ($(this).attr('type') === 'checkbox' && !$(this).data('multiple')) {
                    data[name] = $(this).is(':checked') ? 'yes' : 'no';
                } else if ($(this).attr('type') === 'checkbox' && $(this).data('multiple')) {
                    if ($(this).is(':checked')) {
                        if (!data[$(this).data('name')]) {
                            data[$(this).data('name')] = [];
                        }

                        data[$(this).data('name')].push($(this).val());
                    }
                } else if ($(this).attr('type') === 'radio' && $(this).is(':checked')) {
                    data[name] = $(this).val();
                } else if ($(this).attr('type') === 'file') {
                    data[name + '-file'] = $(this).prop('files')[0];
                    data[name] = true;
                } else if ($(this).attr('type') !== 'radio') {
                    data[name] = $(this).val();
                }
            }
        });

        let formData = new FormData();

        for (let key in data) {
            formData.append(key, data[key]);
        }

        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            dataType: 'json',
            cache: false,
            data: formData,
            processData: false,
            contentType: false,
            error: function (error) {
                form.removeClass('is-loading');
                button.removeAttr('disabled');

                message.removeClass('is-success').addClass('is-error').find('.response').html(errorTxt);

                message.slideDown();

                $('html, body').animate({scrollTop: form.offset().top - ($('.js-site-header').height() + $('.js-menu-indicator-secondary').height())}, 600);
            },
            success: function (data) {
                form.removeClass('is-loading');
                button.removeAttr('disabled');

                if (data.success) {
                    if (data.data && data.data.redirect) {
                        const href = data.data.redirect;

                        if (data.data.redirect_blank) {
                            window.open(href, "", "resizable=yes,toolbar=yes,status=0,location=no,menubar=no,scrollbars=yes");
                            return;
                        }

                        window.location = href;
                        return;
                    }

                    form.find('input:not([name="date_int"]):not([type="radio"]):not([name="post_id"]):not([name="content_layout"]):not([name="mail_subject"]):not([name="where_to_send"]), textarea, select').val('').prop('checked', false);
                    form.find('input[type="radio"]').prop('checked', false);

                    form.find('input[type="checkbox"]').each(function () {
                        const parent = $(this).parents('.js-trigger-next-checkbox');

                        if (parent.length) {
                            parent.next().addClass('h-form').removeAttr('required');
                        }
                    });

                    form.find('.js-file-title').html('');

                    message.removeClass('is-error').addClass('is-success').find('.response').html(successTxt);

                    message.slideDown();

                    form.find('.has-success').removeClass('has-success');
                    form.find('.has-error').removeClass('has-error');
                } else {
                    if (data.data.hasOwnProperty('message_captcha')) {
                        errorTxt = data.data.message_captcha;
                    } else if (form.hasClass('js-show-message-from-error') && data.data.error && $.isArray(data.data.error)) {
                        errorTxt = '<ul>';

                        $.each(data.data.error, function (i, val) {
                            errorTxt += '<li>' + val + '</li>';

                            if (i + 1 >= data.data.error.length) {
                                errorTxt += '</ul>';
                            }
                        });
                    } else {
                        errorTxt = '<ul><li>' + errorTxt + '</li></ul>';
                    }

                    message.removeClass('is-success').addClass('is-error').find('.response').html(errorTxt);

                    message.slideDown();
                }

                $('html, body').animate({scrollTop: message.offset().top - ($('.js-site-header').height() + $('.js-menu-indicator-secondary').height())}, 600);
            }
        });
    });
}

export function customValidation() {
    //Phone numbers should be 10 digits unless the phone number begins with a plus sign.
    window.Parsley.addValidator('oxphone', {
        validateString: function (value) {
            if (!value) {
                return false;
            }

            if (
                (
                    value.replace(/[^0-9]/g, '').length !== 10
                    && value.charAt(0) !== '+'
                ) ||
                value.replace(/[0-9+(-. )]/g, '').length
            ) {
                return false;
            }

            return true;
        },
        messages: {
            en: 'Phone number invalid'
        }
    });

    const $validations = {
        'zipcode': {
            'us': /(^\d{5}$)|(^\d{5}-\d{4}$)/,
            'ca': /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i
        },
        'states': {
            'us': ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'VI', 'WA', 'WV', 'WI', 'WY'],
            'ca': ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'PE', 'SK', 'ON', 'QC', 'YT']
        }
    };

    //ZIP CODES
    window.Parsley.addValidator('oxzipcode', {
        validate: function (value, requirement) {
            if (!value) {
                return false;
            }

            const us = $validations['zipcode']['us'].test(value);
            const ca = $validations['zipcode']['ca'].test(value);

            return requirement === 'ca' ? ca : (requirement === 'us' ? us : us || ca);
        },
        messages: {
            en: 'Zip code invalid'
        }
    });

    //STATE/PROVINCE
    window.Parsley.addValidator('oxstate', {
        validateString: function (value) {
            return ($.inArray(value.toUpperCase(), $validations['states']['us']) !== -1 || $.inArray(value.toUpperCase(), $validations['states']['ca']) !== -1);
        },
        messages: {
            en: 'State/province invalid'
        }
    });
}

export function initTimeplapseForm() {
    let form = document.getElementById('form-timelapse-order-form');
    let option4k = document.getElementById('order-type-option-4k');
    let option1080p = document.getElementById('order-type-option-1080p');
    let resolution = document.getElementById('requested_resolution');

    if(!form || !option4k || !option1080p || !resolution) {
        return;
    }

    option4k.addEventListener('change', onOptionChange);
    option1080p.addEventListener('change', onOptionChange);

    function onOptionChange(e) {
        if(e.target.id === 'order-type-option-4k') {
            option1080p.checked = false;
            resolution.value = '4K';
        }

        if(e.target.id === 'order-type-option-1080p') {
            option4k.checked = false;
            resolution.value = '1080p';
        }

        if(!option4k.checked && !option1080p.checked) {
            resolution.value = '';
            form.classList.remove('order-type-option-1');
        }
        else {
            form.classList.add('order-type-option-1')
        }

        window.setTimeout(() => {
            console.log({
                '4k': option4k.checked,
                '1080p': option1080p.checked,
                'resolution': resolution.value
            });
        }, 0);
    }
}